/* بوّابة المؤسّسة - مصادقة Supabase (منفصلة عن نظام المستخدمين القديم).
   تُنشئ/تفتح حساب المؤسّسة، ثمّ يعمل نظامك القديم داخلها. */
import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import * as api from "./api.js";
import { supabase } from "./supabaseClient.js";

const Ctx = createContext(null);
export const useSupaAuth = () => useContext(Ctx);

export function SupaAuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [needSetup, setNeedSetup] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const p = await api.getProfile();
      setProfile(p);
      setNeedSetup(!p);
      if (p && typeof window !== "undefined") window.__tpmsProfile = { id: p.id, fullName: p.fullName, orgName: p.orgName, email: p.email, isOwner: !!p.isOwner || !!p.is_owner };
      try {
        if (window.__tpmsLogSession) {
          window.__tpmsLogSession = false;
          const ua = navigator.userAgent || "";
          const browser = /CriOS|Chrome/.test(ua) ? "Chrome" : /Firefox|FxiOS/.test(ua) ? "Firefox" : /Edg/.test(ua) ? "Edge" : /Safari/.test(ua) ? "Safari" : "متصفح آخر";
          const os = /iPhone|iPad/.test(ua) ? "iOS" : /Android/.test(ua) ? "Android" : /Mac/.test(ua) ? "macOS" : /Win/.test(ua) ? "Windows" : /Linux/.test(ua) ? "Linux" : "نظام آخر";
          const device = /Mobi|iPhone|Android/.test(ua) ? "جوال" : /iPad|Tablet/.test(ua) ? "لوحي" : "حاسوب";
          supabase.from("session_log").insert({ profile_id: p.id, org_id: p.org_id || window.__tpmsOrg || null, device, browser, os }).then(({ error }) => { if (error) { try { console.error("[session_log]", error.message); import("./errorlog.js").then((m) => { if (m.logError) m.logError("فشل تسجيل الجلسة: " + error.message); }); } catch {} } else { try { import("./errorlog.js").then((m) => { if (m.logError) m.logError("جلسة سجلت بنجاح: " + device + " " + browser); }); } catch {} } });
        }
      } catch {}
    } catch (e) { console.error(e); setProfile(null); }
  }, []);

  useEffect(() => {
    let alive = true;
    const guard = setTimeout(() => { if (alive) setLoading(false); }, 12000);
    (async () => {
      const s = await api.getSession();
      if (!alive) return;
      setSession(s);
      if (s) await refresh();
      clearTimeout(guard);
      setLoading(false);
    })();
    const off = api.onAuthChange(async (s) => {
      setSession(s);
      if (s) await refresh(); else { setProfile(null); setNeedSetup(false); }
    });
    return () => { alive = false; off(); };
  }, [refresh]);

  const value = {
    session, profile, loading, needSetup,
    signIn: async (email, pw) => { const e = await api.signIn(email, pw); if (!e) await refresh(); return e; },
    signUpManager: async (fullName, orgName, email, pw) => api.signUpManager(fullName, orgName, email, pw),
    completeSetup: async (fullName, orgName) => { const r = await api.ensureOrgProfile(fullName, orgName); if (r.ok) await refresh(); return r.ok ? null : r.err; },
    signOut: async () => { await api.signOut(); setProfile(null); setNeedSetup(false); },
  };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
